 <template>
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
            <div class="wrapper">
                <div class="container-wrapper">
                    <div id="alerts-container">
                    </div>
                </div>
            </div>
            <!--OFFERS-->
            <div class="row m-t-25">
                <div class="m-b-20">
                    <div class="col-xs-12 col-lg-6 m-t-10">
                        <h4 class="text-master text-light">
                                {{ serviceDescription }}
                            </h4>
                    </div>

                    <div class="col-xs-12 col-lg-6 text-center" v-if="serviceImage">
                        <img :src="apiBase + serviceImage" width="25%">
                    </div>

                    <div class="clearfix"></div>
                </div>
                <template v-if="!loadingOffers">
                    <div class="panel-group" id="accordion-test" role="tablist" aria-multiselectable="true">
                        <!--Telecomunicaciones-->
                        <div class="panel panel-default" v-for="offer in offersList">
                            <div class="panel-heading" role="tab">
                                <h4 class="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion-test" :href="'#'+offer[0].id" aria-expanded="false" class="collapsed f-text-md">
                                            {{offer[0].categories ? offer[0].categories.name : "Otros"}} <i class="fa fa-angle-down pull-right"></i>
                                        </a>
                                </h4>
                            </div>
                            <div :id="offer[0].id" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div>

                                        <div class="col-xs-12">
                                            <div class="offers-slide">
                                                <div v-for="off in offer">

                                                    <div class="col-xs-12 slick-slide slick-current slick-active">
                                                        <div class="offer-container">
                                                            <div
                                                                data-toggle="modal"
                                                                @click="setModalDataInfo(off)"
                                                                data-target="#buy-offer"
                                                                class="img-holder col-xs-12 b-a b-grey b-rad-lg center"
                                                                :style="'background: url(\''+ getImageLink(off)+'\') no-repeat center; background-size: contain;'">
                                                            </div>
                                                            <div class="offer-data p-l-10 p-r-10">
                                                                <label
                                                                    v-show="off.validity == 1"
                                                                    class="text-danger m-t">
                                                                        Expira {{off.due_date | dateFormat}}
                                                                        <span class="p-l-10 m-l-10 b-l b-grey">
                                                                            {{off.due_date | daysFromNow}}
                                                                        </span>
                                                                </label>
                                                                <h4>{{off.title}}</h4>
                                                                <h4>{{off.offersProvider.name}}</h4>
                                                                <i class="fa fa-map-marker" aria-hidden="true"></i>
                                                                {{off.offersProvider.address}}
                                                            </div>
                                                            <hr>
                                                            <div class="text-center m-b-15">
                                                                <button
                                                                    class="btn btn-success"
                                                                    data-toggle="modal"
                                                                    @click="setModalDataInfo(off)"
                                                                    data-target="#buy-offer">PAGAR
                                                                    <i
                                                                        class="b-l b-white p-l-10 m-l-10 md
                                                                        md-local-offer sm-ico">
                                                                    </i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="clearfix"></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--/Telecomunicaciones-->
                </div>
                </template>
                <template v-else>
                    <div v-else style="text-align: center;">
                        <span class="fa fa-spin fa-spinner"></span>
                    </div>
                </template>
                <!-- modal view offer -->
                <div class="modal fade" id="view-offer">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="col-xs-12 col-lg-6">
                                    <div class="modal-offer-img" style="background: url(&quot;http://apidev.cashdepotint.com&quot;) center center / cover no-repeat;"></div>
                                </div>
                                <div class="col-xs-12 col-lg-6">
                                    <h3></h3>
                                    <p></p>
                                    <ul class="dots-leader">
                                        <li><span>Descuento</span> <span class="text-20 text-bold"> %</span></li>
                                        <li class="m-t-10"><span></span>
                                            <span class="text-20 text-bold"> Cuotas</span>
                                            </li>
                                    </ul>
                                    <div class="clearfix"></div>
                                    <hr>
                                    <h4>
                                    <span class="m-l-10 sm-ico">(<a target="_blank"></a>)</span>
                                </h4>
                                    <p class="m-t-15"><i class="md  md-location-on sm-ico"></i></p>
                                    <p class="m-t-15"><i class="md  md-phone sm-ico"></i></p>
                                    <div class="text-center m-t-35 m-b-15">
                                        <button
                                            class="btn btn-success"
                                            @click="orderOffer(specificOffer)">SOLICITAR
                                            <i class="b-l b-white p-l-10 m-l-10 md  md-local-offer sm-ico"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
                <!--/OFFERS-->
                <!-- modal-content -->
                <div class="modal fade" id="_confirmLogoutModal">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 class="modal-title">Logout</h4>
                            </div>
                            <div class="modal-body">
                                Esta seguro que desea salir del sistema?
                            </div>
                            <div class="modal-footer">
                                <div class="row">
                                    <div class="col-md-12 pull-right">
                                        <a data-dismiss="modal" class="btn btn-default">VOLVER</a>
                                        <a class="btn btn-primary" id="_submitLogout">LOGOUT</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
            </div>
    </div>
    <!-- modal buy offer -->
    <div class="modal fade" id="buy-offer">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="col-xs-12 col-lg-6">
                        <div class="modal-offer-img" :style="'background: url(\''+modalData.offerImg+'\') no-repeat center; background-size: contain;'"></div>
                    </div>
                    <div class="col-xs-12 col-lg-6">
                        <h3>
                            {{modalData.offerName}}
                            <small>
                                <a :href="'//'+modalData.offerProvider.website" target="_blank">
                                    ({{modalData.offerProvider.website}})
                                </a>
                            </small>
                        </h3>
                        <p>{{modalData.offerDescription}}</p>
                        <ul class="dots-leader">
                            <li>
                                <span>Valor</span>
                                <span class="text-20 text-bold" v-if="modalData.offerPrice > 0">
                                    RD{{modalData.offerPrice | currency}}
                                </span>
                                <span class="text-20 text-bold" v-else>
                                    Valor de su factura
                                </span>
                            </li>
                        </ul>
                        <ul class="dots-leader"  v-if="modalData.offerPrice > 0">
                            <li>
                                <span>Descuento</span>
                                <span class="text-20 text-bold">
                                    {{modalData.offerDiscounts}}%
                                </span>
                            </li>
                        </ul>
                        <ul class="dots-leader">
                            <li>
                                <span>Facilidad de Pago</span>
                                <span class="text-20 text-bold">
                                    {{modalData.offerPayment}} {{modalData.offerPaymentFacility}}
                                </span>
                            </li>
                        </ul>
                        <hr>
                        <span class="text-20 text-bold">{{modalData.offerProvider.name}}</span>
                        <br>
                        <i class="fa fa-map-marker" aria-hidden="true"></i> {{modalData.offerProvider.address}}
                        <br>
                        <i class="fa fa-phone" aria-hidden="true"></i> {{modalData.offerProvider.phone}}
                        <div class="clearfix"></div>
                        <div class="text-center m-t-35 m-b-15">
                            <button
                                class="btn btn-success"
                                data-toggle="modal"
                                data-target="#offer-details-check"
                                @click="orderOffer(modalData)">
                                SOLICITAR <i class="b-l b-white p-l-10 m-l-10 md  md-local-offer sm-ico"></i>
                            </button>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
</template>

<script>
export default {
    data() {
        return {
            offers: [],
            specificOffer: [],
            loadingOffers: true,
            serviceType: 0,
            serviceDescription: '',
            serviceImage: '',
            imageNotFoundUrl: "http://3ie87c2dond928rt2e2zzo8o.wpengine.netdna-cdn.com/wp-content/themes/gonzo/images/no-image-featured-image.png",
            modalData: {
                offerName: '',
                offerId: '',
                offerDescription: '',
                offerPaymentFacility: '',
                offerProvider: {},
                offerImg: '',
                offerPayment: 0,
                offerDiscounts: 0,
                offerPrice: 0,
            },
            offersList: [],
            api: apiUrl,
            apiBase: apiUrl.replace('/v1', ''),
            mediaUrl: mediaUrl,
        }
    },
    created() {
        this.serviceType = this.$route.params.id;
        this.getAllOffers();
        this.getServiceData();
    },
    filters : {
        dateFormat: function (date) {
            return moment(date).format("DD/MM/YYYY");
        },
        daysFromNow : function (date) {
            date = moment(date);
            let todayDate = moment();
            let daysDiff = date.diff(todayDate, 'days');
            let formattedDate = `-${daysDiff} días`;
            if (daysDiff < 0) {
                formattedDate = "Vencida";
            } else if (daysDiff == 0) {
                formattedDate = "Vence Hoy";
            }
            return formattedDate;
        }
    },
    watch: {
        'offers'() {
            this.offersList = _.groupBy(this.offers, 'categories.name');
        },
        'offersList'() {
            this.$nextTick(() => {
                this.startSlick('.offers-slide');
            });
        }
    },
    methods: {
        setModalDataInfo(offer) {
            this.modalData.offerName = offer.title;
            this.modalData.offerDescription = offer.description;
            this.modalData.offerPrice = offer.cost;
            this.modalData.offerDiscounts = offer.discount_percent;
            this.modalData.offerId = offer.id;
            // if (Number(offer.fee)) {
            //     this.modalData.offerPaymentFacility = 'cuotas';
            //     this.modalData.offerPayment = offer.fee;
            // } else {
            //     this.modalData.offerPaymentFacility = 'días';
            //     this.modalData.offerPayment = offer.typeDays.days;
            // }
            this.modalData.offerPaymentFacility = 'cuotas';
            if (offer.fee == "0") {
                this.modalData.offerPayment = 2;
            } else {
                this.modalData.offerPayment = offer.fee;
            }
            this.modalData.offerProvider = offer.offersProvider;
            this.modalData.offerImg = this.getImageLink(offer);
        },
        getAllOffers: function() {
            this.loadingOffers = true;
            this.$http.get(apiUrl + `/offers?relationships=categories,offersProvider,typeDays&q=(is_deleted:0,service_type_id:${this.serviceType},status_id:1)&limit=1000`).then(response => {
                this.offers = response.data;
                this.loadingOffers = false;

                $(document).ready(function() {
                    $(".panel.panel-default").on("click", function(element) {
                        $('#accordion-test').on('shown.bs.collapse', function(event) {
                            if ($(".slick-initialized").length) {
                                $('.offers-slide').slick('unslick');
                            }

                            $('.offers-slide').slick({
                                lazyLoad: 'ondemand',
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                dots: true,
                                infinite: false,
                                speed: 300,
                                adaptiveHeight: true,
                                responsive: [{
                                        breakpoint: 1440,
                                        settings: {
                                            slidesToShow: 3,
                                            slidesToScroll: 1,
                                            infinite: true,
                                            dots: true
                                        }
                                    },
                                    {
                                        breakpoint: 1024,
                                        settings: {
                                            slidesToShow: 2,
                                            slidesToScroll: 1,
                                            infinite: true,
                                            dots: true
                                        }
                                    },
                                    {
                                        breakpoint: 600,
                                        settings: {
                                            slidesToShow: 1,
                                            slidesToScroll: 1
                                        }
                                    },
                                    {
                                        breakpoint: 480,
                                        settings: {
                                            slidesToShow: 1,
                                            slidesToScroll: 1
                                        }
                                    }
                                ]
                            });

                        });
                    });
                });
            });
        },
        getImageLink(offer) {
            if(offer.image) {
                return `${this.apiBase}${offer.image}`;
            }
            return this.imageNotFoundUrl;
        },
        getServiceData() {
            this.$http.get(`${apiUrl}/service-types/${this.serviceType}`).then(response => {
                console.log(response);
                this.serviceDescription = response.data.description;
                this.serviceImage = response.data.image;
            });
        },
        orderOffer: function(offer) {
            let data = new FormData();

            data.append('user_id', userId);
            data.append('offer_id', offer.offerId);

            this.$http({
                emulateJSON: true,
                emulateHTTP: true,
                url: apiUrl + '/users/' + userId + "/offers/" + offer.offerId,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data,
            }).then(function(response) {
                swal("¡Oferta Solicitada!", `El equipo de ${offer.offerProvider.name} lo contactará pronto`, "success");
            }, response => {
                sweetAlert("Oops...", "Ha ocurrido un error solicitando la oferta " + response.status.message, "error");
            });

        },
        viewOfferInfo: function(id) {
            $('#viewOffer').modal('show');

            let fillOffer = this.offers.find(offer => {
                return offer.id == id;
            });

            this.specificOffer = fillOffer;
        },
        startSlick(slickContainer) {
            $(slickContainer).slick({
                lazyLoad: 'ondemand',
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                infinite: false,
                speed: 300,
                adaptiveHeight: true,
                responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    },
}
</script>


// WEBPACK FOOTER //
// client-offers-pagatodo.vue?3df1a6a4